import React, { useEffect, useState } from "react";
import axios from "axios";
import { backend_url } from "../App";
import "./CSS/varietyAccessories.css";
import { ToastContainer, toast } from "react-toastify";
import { isAdmin } from "../utils/roleUtils";
import "react-toastify/dist/ReactToastify.css";
import MediaField from "../Components/MediaField/MediaField";
import DownloadButton from "../Components/MediaField/DownloadButton";

const FeaturedIn = () => {
    const [items, setItems] = useState([]);
    const [formData, setFormData] = useState({
        image: null,
        icon_image: null,
    });
    const [showConfirm, setShowConfirm] = useState(false);
    const [selectedItemId, setSelectedItemId] = useState(null);
    const [editingId, setEditingId] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [existing, setExisting] = useState({ image: "", icon_image: "" });

    useEffect(() => {
        fetchItems();
    }, []);

    const fetchItems = async () => {
        try {
            const response = await axios.get(`${backend_url}/api/featured-in`);
            setItems(response.data);
        } catch (error) {
            toast.error("Error fetching items:", error.response?.data?.error || error.message);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.image && !existing.image) {
            toast.error("Please choose a Featured-In image");
            return;
        }
        if (!formData.icon_image && !existing.icon_image) {
            toast.error("Please choose a logo");
            return;
        }
        if (editingId && !formData.image && !formData.icon_image) {
            toast.info("Nothing changed");
            closeModal();
            return;
        }

        const data = new FormData();
        if (formData.image) data.append("image", formData.image);
        if (formData.icon_image) data.append("icon_image", formData.icon_image);

        try {
            if (editingId) {
                await axios.put(`${backend_url}/api/featured-in/${editingId}`, data);
                toast.success("Item Updated Successfully");
            } else {
                await axios.post(`${backend_url}/api/featured-in`, data);
                toast.success("Item Added Successfully");
            }
            fetchItems();
            closeModal();
        } catch (error) {
            toast.error(error.response?.data?.error || "Error saving item");
        }
    };

    const handleEdit = (item) => {
        setFormData({
            image: null,
            icon_image: null,
        });
        setExisting({ image: item.image || "", icon_image: item.icon_image || "" });
        setEditingId(item._id);
        setShowModal(true);
    };

    const handleDelete = (id) => {
        setSelectedItemId(id);
        setShowConfirm(true);
    };

    const confirmDelete = async () => {
        try {
            await axios.delete(`${backend_url}/api/featured-in/${selectedItemId}`);
            toast.success("Item deleted successfully");
            fetchItems();
        } catch (error) {
            toast.error("Error deleting item:", error.response?.data?.error || error.message);
        } finally {
            setShowConfirm(false);
        }
    };

    const closeModal = () => {
        setShowModal(false);
        setEditingId(null);
        setFormData({ image: null, icon_image: null });
        setExisting({ image: "", icon_image: "" });
    };

    return (
        <div className="variety-admin">
            <div className="headerSections">
                <div className="head-title">Featured In</div>
                <button className="add-btn" onClick={() => setShowModal(true)}>
                    + Add Featured In
                </button>
            </div>

            {showModal && (
                <div className="modal-overlay" onClick={closeModal}>
                    <div className="modal" onClick={(e) => e.stopPropagation()}>
                        <h2>{editingId ? "Edit Featured-In" : "Add Featured-In"}</h2>
                        <form onSubmit={handleSubmit} className="variety-form">
                            <MediaField
                                id="image"
                                label="Featured-In Image"
                                file={formData.image}
                                existingUrl={existing.image}
                                onFileSelect={(file) => setFormData({ ...formData, image: file })}
                            />
                            <MediaField
                                id="icon_image"
                                label="Logo"
                                file={formData.icon_image}
                                existingUrl={existing.icon_image}
                                onFileSelect={(file) => setFormData({ ...formData, icon_image: file })}
                            />
                            <div className="form-buttons">
                                <button type="submit" className="submit-btn">
                                    {editingId ? "Update" : "Add"}
                                </button>
                                <button type="button" onClick={closeModal} className="cancel-btn">
                                    Cancel
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            <table className="variety-table">
                <thead>
                    <tr>
                        <th>Featured-In Image</th>
                        <th>Logo</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {items.map((item) => (
                        <tr key={item._id}>
                            <td>
                                {item.image && (
                                    <div className="media-cell">
                                        <img
                                            src={item.image}
                                            alt="item"
                                            style={{ width: "50px", height: "50px" }}
                                        />
                                        <DownloadButton url={item.image} />
                                    </div>
                                )}
                            </td>
                            <td>
                                {item.icon_image && (
                                    <div className="media-cell">
                                        <img
                                            src={item.icon_image}
                                            alt="icon"
                                            style={{ width: "50px", height: "50px" }}
                                        />
                                        <DownloadButton url={item.icon_image} />
                                    </div>
                                )}
                            </td>
                            <td>
                                <button onClick={() => handleEdit(item)}>Edit</button>
                                {isAdmin() && <button onClick={() => handleDelete(item._id)}>Delete</button>}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {showConfirm && (
                <div className="confirm-popup">
                    <div className="confirm-content">
                        <p>Are you sure you want to delete this item?</p>
                        <div className="popup-actions">
                            <button onClick={confirmDelete} className="confirm-btn">
                                Confirm
                            </button>
                            <button onClick={() => setShowConfirm(false)} className="cancel-btn">
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <ToastContainer />
        </div>
    );
};

export default FeaturedIn;
